const ATTRIBUTIONS_COMMERCIALES_AUDITEES = new Map([
  ["9-74316", { commercial: "Adrien", attribution_locale: "AUDIT_COMMANDE_INTERCLUB_2026-08-31" }]
]);

export function appliquerAttributionsCommercialesAuditees(clubs = []) {
  return clubs.map((club) => {
    const code = String(club?.numero_compte_interclub || "").trim();
    const attribution = ATTRIBUTIONS_COMMERCIALES_AUDITEES.get(code);
    return attribution ? { ...club, ...attribution } : club;
  });
}

export { ATTRIBUTIONS_COMMERCIALES_AUDITEES };
